import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../state/AuthContext";

export default function ReportsPage() {
  const { http } = useContext(AuthContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    async function load() {
      setLoading(true);
      setError(null);
      try {
        const res = await http.get("/api/reports/summary");
        if (alive) setData(res.data);
      } catch (err) {
        if (alive) setError(err?.response?.data?.message || "Failed to load reports.");
      } finally {
        if (alive) setLoading(false);
      }
    }
    load();
    return () => {
      alive = false;
    };
  }, [http]);

  const summary = data?.summary || {};

  return (
    <div className="d-grid gap-3">
      <div>
        <h4 className="mb-1">Reports</h4>
        <p className="text-muted mb-0">View all report lists and summary information.</p>
      </div>

      {error ? <div className="alert alert-danger">{error}</div> : null}
      {loading ? <div className="text-muted">Loading...</div> : null}

      {data ? (
        <>
          <div className="row g-3">
            <div className="col-12 col-md-3">
              <div className="card shadow-sm">
                <div className="card-body">
                  <div className="text-muted small">Total Enquiries</div>
                  <div className="fs-3 fw-semibold">{summary.totalEnquiries}</div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="card shadow-sm">
                <div className="card-body">
                  <div className="text-muted small">New</div>
                  <div className="fs-3 fw-semibold">{summary.newEnquiries}</div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="card shadow-sm">
                <div className="card-body">
                  <div className="text-muted small">In Progress</div>
                  <div className="fs-3 fw-semibold">{summary.inProgress}</div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="card shadow-sm">
                <div className="card-body">
                  <div className="text-muted small">Completed</div>
                  <div className="fs-3 fw-semibold">{summary.completed}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-12 col-lg-4">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <h6>All Reports List</h6>
                  <div className="list-group list-group-flush">
                    {data.reports.map((report) => (
                      <div key={report.code} className="list-group-item px-0">
                        {report.name}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <h6>Status Wise</h6>
                  <div className="list-group list-group-flush">
                    {data.statusWise.map((item) => (
                      <div
                        key={item.statusCode}
                        className="list-group-item px-0 d-flex justify-content-between"
                      >
                        <span>{item.statusName}</span>
                        <span className="fw-semibold">{item.total}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <h6>Work Type Wise</h6>
                  <div className="list-group list-group-flush">
                    {data.workTypeWise.map((item) => (
                      <div
                        key={item.workTypeName}
                        className="list-group-item px-0 d-flex justify-content-between"
                      >
                        <span>{item.workTypeName}</span>
                        <span className="fw-semibold">{item.total}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}
